export default [
    {
      name: "Roboto",
      type: "font",
      path: "./fonts/Roboto_Regular.json",
    },
  ]; 